export default "__VITE_ASSET__f73ecdda__"